import React from "react";

const ChatTransferred: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: 16,
          padding: "32px 24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        {/* Logo */}
        <img
          src="/idlesslogo.png"
          alt="IDless Logo"
          style={{
            width: 64,
            height: 64,
            borderRadius: 12,
            objectFit: "cover",
            marginBottom: 20,
          }}
        />

        {/* Title */}
        <h3 style={{ marginBottom: 12 }}>
          Chat has been transferred to the mobile app
        </h3>
      </div>
    </div>
  );
};

export default ChatTransferred;
